export type EventType =
  | 'apply_click'
  | 'form_start'
  | 'industry_selected'
  | 'position_selected'
  | 'application_submitted';

export type DataLayerEvent = {
  event: EventType;
  [key: string]: string | boolean;
};

export const pushToDataLayer = (event: DataLayerEvent) => {
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push(event);
};
